import { useViewportLayout } from 'utils/helper-device'
import deviceSize from 'utils/deviceSizes/deviceSize'

const useDeviceSizes = () => {
	
	const { width } = useViewportLayout();
	return deviceSize.all( width );
}

export const useIsMobile = () => {
	const deviceSizes = useDeviceSizes()
	
	return deviceSizes.isMobile;
}

export const useIsTablet = () => {
	const deviceSizes = useDeviceSizes()
	
	return deviceSizes.isTablet;
}

export const useIsDesktop = () => {
	const deviceSizes = useDeviceSizes()
	
	return deviceSizes.isDesktop;
}

export default useDeviceSizes
